<template>
  <div class="page page__list">
    <search-bar @search="onSearchWithId" name="pr_detail,pr_code,wh_description" placeholder="输入物料、仓库进行查找" ref="searchBar" />
    <filter-bar @change="onSearchWithId" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearchWithId" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="(item, index) in items"
        :key="index"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{item.pr_code}}{{item.pr_detail}}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.pi_date}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{(item.pd_endqty) + item.pr_unit}}</p>
          <p class="list-item-muted">
            {{pi_class(item.pi_class)}}
            <span v-if="item.pd_endamount > 0"> {{numberFormat(item.pd_endamount, "#,##0.00") + "元"}}</span>
          </p>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}单</label>
      <em class="list-footer__value">
        合计：
        <span v-format="'#,##0.00'">{{getTotal()}}</span>元
      </em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/storage/report/prodioDetail",
      params: {
        mode: "DETAIL",
        number: 1,
        size: 20,
        calculateFields: JSON.stringify([
          {"field":"pd_inqty","operation":"sum"},
          {"field":"pd_outqty","operation":"sum"},
          {"field":"pd_endqty"},
          {"field":"pd_endamount"}
        ]),
        queryId: Math.random().toString(36),
        page: 1,
        start: 0,
        limit: 999999
      },
      filters: [
        {
          type: "period",
          name: "pd_ym"
        }
      ],
    };
  },
  methods: {
    onSearchWithId(callback) {
      this.params.queryId = Math.random().toString(36)
      this.onSearch(callback)
    },
    gotoView(item) {
      this.$router.push({
        name: "StockProdiodetailReportDetail",
        params: {
          initData: Object.assign({}, item),
        },
      });
    },
    getTotal() {
      var me = this,
        items = me.items,
        total = 0
      items.forEach((item) => {
        total += item.pd_endamount;
      });
      return total;
    },
    pi_class(type) {
      type = type.toUpperCase()
      if(type=="PURCIN"){
          type = '采购入库';
      }else if(type=="PURCOUT"){
          type = '采购退货';
      }else if(type=="SALEOUT" ){
          type = '销售出货';
      }else if(type=="SALERETURN"){
          type = '销售退货';
      }else if(type=="OTHERIN"){
          type = '其它入库';
      }else if(type=="OTHEROUT"){
          type = '其它出库';
      }else if(type=="RESERVEINITIALIZE"){
          type = '库存初始化';
      }else if(type=="STOCKPROFIT"){
          type = '盘盈入库';
      }else if(type=="STOCKLOSS"){
          type = '盘亏出库';
      }else if(type=="MOVEOUT"){
          type = '移仓单';
      }else if(type=="MOVEIN"){
          type = '移仓单';
      }else if(type=="MAKEPICK"){
          type = '生产领料';
      }else if(type=="MAKERETURN"){
          type = '生产退料';
      }else if(type=="MAKEIN"){
          type = '完工入库';
      }else if(type=="OSMAKEPICK"){
          type = '外协领料';
      }else if(type=="OSMAKERETURN"){
          type = '外协退料';
      }else if(type=="OSMAKEIN"){
          type = '外协入库';
      }else if(type=="OSMAKEINBACK"){
          type = '外协退货';
      }else if(type=="MAKEDISMANTLE"){
          type = '工单拆件';
      }else if(type=="OSMAKEDISMANTLE"){
          type = '外协拆件';
      } 
      return type;
    }
  },
};
</script>